import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTextMotion: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconTextMotion"><Path d="M12.25 13.5H18.75" stroke="currentColor" strokeLinecap="square"/><Path d="M5.5 6.5H10.5" stroke="currentColor" strokeLinecap="square"/><Path d="M2.5 12H8.5" stroke="currentColor" strokeLinecap="square"/><Path d="M3.5 17.5H6.5" stroke="currentColor" strokeLinecap="square"/><Path d="M9.5 19.5L15.5 5L21.5 19.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconTextMotion;
